import {
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  setPersistence,
  browserLocalPersistence,
  type User,
} from "firebase/auth";
import { auth } from "@/plugins/firebase.client";

export const useAuth = () => {
  const user = useState<User | null>("firebaseUser", () => null);
  const router = useRouter();

  const login = async (
    email: string,
    password: string,
    rememberMe: boolean = false,
  ) => {
    try {
      // Set persistence before signing in - explicitly requested for login
      await setPersistence(auth, browserLocalPersistence);

      await signInWithEmailAndPassword(auth, email, password);

      // Save credentials to localStorage if remember me is checked
      if (rememberMe) {
        localStorage.setItem("rememberedEmail", email);
        localStorage.setItem("rememberedPassword", password);
      } else {
        localStorage.removeItem("rememberedEmail");
        localStorage.removeItem("rememberedPassword");
      }

      router.push("/admin");
    } catch (error) {
      console.error("Login failed:", error);
      throw error;
    }
  };

  const getRememberedCredentials = () => {
    if (process.client) {
      const email = localStorage.getItem("rememberedEmail");
      const password = localStorage.getItem("rememberedPassword");
      return { email: email || "", password: password || "" };
    }
    return { email: "", password: "" };
  };

  const logout = async () => {
    try {
      await firebaseSignOut(auth);
      user.value = null;
      router.push("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return {
    user,
    login,
    logout,
    getRememberedCredentials,
  };
};
